// extracted by mini-css-extract-plugin
module.exports = {"carouselList":"CarouselImage-Jtails_carouselList_1mhHt","itemCarouselImageJtails":"CarouselImage-Jtails_itemCarouselImageJtails_sMsqK"};